<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <StatusBar :params="this.$route.query.params" />

    <!-- 卡片顯示樣式 -->
    <div class="tool-list" v-if="personList.length > 0">
      <span class="mr-2">共計：{{ totalPerson }}人</span>
      <CardStyle @changeStyle="changeStyle" />
    </div>

    <!-- 查詢列 -->
    <SearchBar
      :show="showSearchBar"
      @showSearchBar="showSearchBar = !showSearchBar"
      @search="(currentPage = 1), getAppointResult()"
    >
      <template v-slot:searchItem>
        <el-input
          class="w-100 item-bottom"
          clearable
          placeholder="關鍵字（姓名、Email、聯絡電話）"
          v-model.trim="searchCondition.Keyword"
        />
        <el-date-picker
          class="w-100 item-bottom"
          type="daterange"
          clearable
          :picker-options="{
            disabledDate: $common.disabledDateAfterToday,
          }"
          range-separator="-"
          start-placeholder="面談日期(起)"
          end-placeholder="面談日期(迄)"
          v-model="searchCondition.InterviewDateRange"
        />

        <el-select
          class="w-100 item-bottom"
          filterable
          clearable
          placeholder="單位面試主管"
          v-model="searchCondition.InterviewSupervisor"
        >
          <el-option
            v-for="supervisor in supervisorOptions"
            :key="supervisor.Guid"
            :label="supervisor.Name"
            :value="supervisor.Name"
          >
          </el-option>
        </el-select>

        <el-select
          class="w-100 item-bottom"
          filterable
          clearable
          placeholder="HR 面試人員"
          v-model="searchCondition.InterviewHR"
        >
          <el-option
            v-for="supervisor in supervisorOptions"
            :key="supervisor.Guid"
            :label="supervisor.Name"
            :value="supervisor.Name"
          >
          </el-option>
        </el-select>

        <el-select
          class="w-100 item-bottom"
          multiple
          clearable
          placeholder="應聘者狀態"
          v-model="searchCondition.Status"
        >
          <el-option
            v-for="status in candidateStatusOptions"
            :key="status.key"
            :label="status.value"
            :value="status.value"
          >
          </el-option>
        </el-select>
        <el-select
          class="w-100 item-bottom"
          multiple
          clearable
          placeholder="報到狀態"
          v-model="searchCondition.OnBoard"
        >
          <el-option
            v-for="status in onBoardStatusOptions"
            :key="status.key"
            :label="status.value"
            :value="status.value"
          >
          </el-option>
        </el-select>
        <el-select
          class="w-100 item-bottom"
          multiple
          clearable
          placeholder="報到意願"
          v-model="searchCondition.Intention"
        >
          <el-option
            v-for="status in intentionOptions"
            :key="status.key"
            :label="status.value"
            :value="status.value"
          >
          </el-option>
        </el-select>
      </template>
    </SearchBar>

    <!-- 人員卡片 -->
    <div
      class="person-card-list"
      :class="{
        'list-style': gridStyle == 'list',
        'block-style': gridStyle == 'block',
      }"
    >
      <div
        v-for="(person, index) in personList"
        :key="index"
        class="person-card infinite-list-item"
      >
        <PersonCard
          ref="personCard"
          :showCheckbox="true"
          :person="person"
          @updatePersonList="updatePersonList"
        >
          <template v-slot:note="{ props }">
            <button type="button" @click="clickResumeNote(props)">
              <eva-icon name="color-picker-outline" fill="#000" />
            </button>
          </template>

          <template v-slot:tag="{ props }">
            <div class="result">{{ props.ApprovalResult }}</div>
          </template>

          <template v-slot:middleContent="{ props }">
            <table class="appoint-result-table">
              <tr>
                <th>任用部門</th>
                <td>{{ props.AppointmentDepartment }}</td>
              </tr>
              <tr style="height: 60px">
                <th>任用職務</th>
                <td>{{ props.Position }}</td>
              </tr>
              <tr>
                <th>簽核者</th>
                <td>
                  {{ props.Approver }}
                </td>
              </tr>
              <tr>
                <th>單位面試主管</th>
                <td>{{ props.InterviewSupervisor[0] }}</td>
              </tr>
              <tr>
                <th>HR 面試人員</th>
                <td>{{ props.InterviewHR[0] }}</td>
              </tr>
              <tr>
                <th>面談備註</th>
                <td>
                  {{ props.InterviewApprovalResultRemark }}
                </td>
              </tr>
              <tr>
                <th>通知錄取</th>
                <td>
                  <span v-if="props.HireNoticeMailTime">
                    {{ $common.dateFormatter(props.HireNoticeMailTime) }}
                  </span>
                  <span v-else>尚未</span>
                </td>
              </tr>
              <tr>
                <th>通知報到</th>
                <td>
                  <span v-if="props.ReportNoticeMailTime">
                    {{ $common.dateFormatter(props.ReportNoticeMailTime) }}
                  </span>
                  <span v-else>尚未</span>
                </td>
              </tr>
              <tr>
                <th>報到意願</th>
                <td>
                  <el-tooltip
                    v-if="props.OnBoardIntentionReason"
                    class="item"
                    effect="dark"
                    :content="props.OnBoardIntentionReason"
                    placement="right"
                  >
                    <span>
                      {{ props.OnBoardIntention }}
                    </span>
                  </el-tooltip>
                  <template v-else>
                    {{ props.OnBoardIntention }}
                  </template>
                </td>
              </tr>
              <tr>
                <th>報到狀態</th>
                <td>
                  {{ props.OnBoard }}
                </td>
              </tr>
              <tr>
                <th>智財變更註記</th>
                <td>
                  {{ props.IPChangeTag === true ? "是" : "否" }}
                </td>
              </tr>
            </table>
          </template>

          <template v-slot:buttonGroup="{ props }">
            <el-dropdown>
              <button type="button" class="el-dropdown-link">
                檢視資訊<i class="el-icon-arrow-down el-icon--right"></i>
              </button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="showDetailModal(props)">
                  檢視履歷
                </el-dropdown-item>
                <el-dropdown-item @click.native="showProgressRecord(props)">
                  檢視歷程
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <template
              v-if="
                props.ApprovalResult === '通過' && props.OnBoard === '待報到'
              "
            >
              <!-- 通知信 -->
              <el-dropdown class="mr-1">
                <button type="button" class="el-dropdown-link">
                  通知信<i class="el-icon-arrow-down el-icon--right"></i>
                </button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="sendMail(props, 'hire')">
                    錄取通知
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="sendMail(props, 'report')">
                    報到通知
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- 人事資料 -->
              <el-dropdown
                v-if="props.ReportNoticeMailTime || props.ReportNoticeMailTime"
                class="mr-1"
              >
                <button type="button" class="el-dropdown-link">
                  人事資料<i class="el-icon-arrow-down el-icon--right"></i>
                </button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    @click.native="
                      $router.push({
                        path:
                          props.ResumeType === 'IDL'
                            ? '/manager/form/idl/personnelinformation'
                            : '/manager/form/dl/personnelinformation',
                        query: {
                          matchId: `${props.MatchId}`,
                          personData: JSON.stringify({
                            Name: person.Name,
                            Position: person.Position,
                          }),
                        },
                      })
                    "
                  >
                    人事資料表
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="clickHcpData(props)">
                    HCP人事資料維護
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <button
              v-if="props.ReportNoticeMailTime"
              type="button"
              @click="openOnBoardModal(props)"
            >
              報到確認
            </button>
          </template>
        </PersonCard>
      </div>
    </div>

    <el-pagination
      v-if="personList.length > 0"
      background
      layout="prev, pager, next"
      :total="totalPerson"
      :page-size="9"
      @current-change="changePage"
    >
    </el-pagination>

    <!-- 履歷 Note -->
    <ResumeNoteModal :personData="interviewee" />

    <!-- 功能列 -->
    <ActionBar
      :show="showActionBar"
      :totalPerson="totalPerson"
      :selectedCardList="choosePersonList"
      style="z-index: 10000"
      @showActionBar="showActionBar = !showActionBar"
      @selectAllCards="selectAllCards"
      @clearSelectCard="clearSelectCard"
    >
      <template v-slot:button>
        <button type="button" class="action-btn" @click="exportOffer">
          <eva-icon name="download-outline" fill="#FFF" />
          <span>下載 Offer</span>
        </button>
      </template>
    </ActionBar>

    <!-- 錄取通知 -->
    <HireMailModal :personData="personData" @updatePerson="updatePerson" />

    <!-- 報到通知 -->
    <ReportMailModal :personData="personData" @updatePerson="updatePerson" />

    <!-- HCP -->
    <HcpDataModal :personData="personData" />

    <!-- 報到確認 Modal -->
    <div
      id="checkOnBoardModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog">
        <img class="cord" src="@/assets/img/name_card_cord.png" alt="" />
        <ValidationObserver ref="reported" v-slot="{ handleSubmit, reset }">
          <form @reset.prevent="reset">
            <div class="modal-content">
              <div class="modal-header">
                <span>完成報到</span>
              </div>
              <div class="modal-body">
                <div class="info">
                  <div class="text-wrap">
                    <div class="name">{{ person.Name }}</div>
                    <div class="position">{{ person.Position }}</div>
                  </div>
                </div>
                <div class="state-wrap">
                  <ValidationProvider
                    tag="div"
                    rules="required"
                    class="w-100"
                    v-slot="{ errors }"
                  >
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        :value="0"
                        v-model="person.OnBoardStatus"
                      />
                      <label for="" class="form-check-label"> 待報到 </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        :value="1"
                        v-model="person.OnBoardStatus"
                      />
                      <label for="" class="form-check-label"> 完成報到 </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        :value="-99"
                        v-model="person.OnBoardStatus"
                      />
                      <label for="" class="form-check-label"> 取消報到 </label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input
                        class="form-check-input"
                        type="radio"
                        :value="-1"
                        v-model="person.OnBoardStatus"
                      />
                      <label for="" class="form-check-label"> 延期報到 </label>
                    </div>
                    <p class="text-danger" style="font-size: 13px">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </div>
                <div
                  v-if="
                    person.OnBoardStatus === 1 || person.OnBoardStatus === -1
                  "
                  class="number-wrap"
                >
                  <ValidationProvider
                    tag="div"
                    rules="required"
                    name="報到日期"
                    class="w-100"
                    v-slot="{ errors }"
                  >
                    <el-date-picker
                      class="w-100"
                      type="date"
                      value-format="yyyy-MM-dd"
                      :picker-options="{
                        disabledDate: $common.disabledDateBeforeToday,
                      }"
                      placeholder="請選擇日期"
                      v-model="person.NewOnBoardDate"
                    />
                    <span class="text-danger" style="font-size: 13px">
                      {{ errors[0] }}
                    </span>
                  </ValidationProvider>
                </div>
                <div v-else-if="person.OnBoardStatus === -99">
                  <ValidationProvider
                    tag="div"
                    rules="required"
                    name="原因"
                    class="w-100"
                    v-slot="{ errors }"
                  >
                    <el-cascader
                      class="w-100"
                      :options="notArrivedCategoryOptions"
                      clearable
                      :show-all-levels="true"
                      placeholder="請選擇原因"
                      v-model="person.notArrivedCategory"
                    />
                    <p class="text-danger" style="font-size: 13px">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                  <textarea
                    class="form-control w-100"
                    type="text"
                    rows="3"
                    maxlength="200"
                    placeholder="請輸入備註"
                    v-model="person.OnBoardRemark"
                  />
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="reset"
                  class="btn btn-secondary"
                  aria-label="關閉"
                  data-dismiss="modal"
                >
                  取消
                </button>
                <button
                  type="button"
                  class="btn btn-success"
                  @click="handleSubmit(confirmedOnBoard)"
                >
                  確認
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 檢視資訊 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a @click.prevent="detailCurrentPage = 0">
              <span>
                <eva-icon name="person-outline" fill="#FFF"></eva-icon>
                履歷
              </span>
            </a>
            <a @click.prevent="detailCurrentPage = 1">
              <span>
                <eva-icon name="message-circle-outline" fill="#FFF"></eva-icon>
                面談紀錄
              </span>
            </a>
            <a @click.prevent="detailCurrentPage = 2">
              <span>
                <eva-icon name="clipboard-outline" fill="#FFF"></eva-icon>
                任用單
              </span>
            </a>
            <div
              class="close-show-detail"
              @click.prevent="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              ></eva-icon>
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 0" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">履歷</div>
                    <div class="item text-right">
                      <button
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        @click="$common.downloadResumePDF(ResumeType, ResumeId)"
                      >
                        下載 PDF
                      </button>
                    </div>
                  </div>
                  <IdlResume
                    v-if="ResumeType === 'IDL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                  <DlResume
                    v-if="ResumeType === 'DL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 1" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">面談紀錄</div>
                    <div class="item"></div>
                  </div>
                  <InterviewRecord :MatchId="MatchId"></InterviewRecord>
                </section>
              </perfect-scrollbar>
            </transition>
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 2" class="page">
                <section class="page-inner">
                  <div class="title">
                    <Logo class="item" />
                    <div class="item text-center">任用單</div>
                    <div class="item"></div>
                  </div>
                  <AppointmentRecord :MatchId="MatchId"></AppointmentRecord>
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>

    <!-- 檢視歷程 -->
    <ProgressRecordModal :Name="Name" :UserId="UserId" :Email="Email" />
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
// 招募狀態列表
import StatusBar from "@/components/back/OpeningManage/StatusBar";
// 公司Logo
import Logo from "@/components/company/Logo.vue";
// 卡片樣式
import CardStyle from "@/components/back/Card/CardStyle";
// 人員卡片
import PersonCard from "@/components/back/Card/Person";
// 功能列
import ActionBar from "@/components/back/ToolBar/ActionBar";
// 查詢列
import SearchBar from "@/components/back/ToolBar/SearchBar";
// 履歷 Note
import ResumeNoteModal from "@/components/back/Modal/ResumeNote";
// 錄取通知
import HireMailModal from "@/components/back/Modal/HireMail";
// 報到通知
import ReportMailModal from "@/components/back/Modal/ReportMail";
// HCP
import HcpDataModal from "@/components/back/Modal/HcpData";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";
// 面談紀錄
import InterviewRecord from "@/components/back/CandidateData/InterviewRecord";
// 任用單
import AppointmentRecord from "@/components/back/CandidateData/AppointmentRecord";
// 歷程
import ProgressRecordModal from "@/views/back/TalentQuery/ResultPage/Modal/ProgressRecord";

export default {
  name: "AppointResult",

  props: {
    did: { // 需求單號
      type: String,
    }
  },

  components: {
    StatusBar,
    Logo,
    CardStyle,
    PersonCard,
    ActionBar,
    SearchBar,
    ResumeNoteModal,
    HireMailModal,
    ReportMailModal,
    HcpDataModal,
    IdlResume,
    DlResume,
    InterviewRecord,
    AppointmentRecord,
    ProgressRecordModal,
  },
  data() {
    return {
      // 卡片顯示樣式 有 block / list 兩種
      gridStyle: "block",

      // data
      personList: [],
      interviewee: {},

      // 功能列
      showActionBar: false, // 預設不顯示
      choosePersonList: [],

      // 檢視資訊
      MatchId: null,
      ResumeId: null,
      isShowDetail: false, // 預設不顯示
      detailCurrentPage: 0, // 點擊選項
      ResumeType: null, // 履歷種類
      showInterviewRecord: false, // 面談紀錄

      supervisorOptions: [],

      // 報到確認
      person: {
        MatchId: null,
        Name: null,
        Position: null,
        OnBoardStatus: 0,
        EmployeeNo: null,
      },
      // 報到未到原因選項
      notArrivedCategoryOptions: [],

      // 錄取 & 報到通知
      personData: {},

      // 查詢列
      showSearchBar: false,
      searchCondition: {},

      candidateStatusOptions: [
        { key: "新建", value: "新建" },
        { key: "簽核中", value: "簽核中" },
        { key: "通過", value: "通過" },
        { key: "否決", value: "否決" },
      ],

      onBoardStatusOptions: [
        { key: "待報到", value: "待報到" },
        { key: "完成報到", value: "完成報到" },
        { key: "取消報到", value: "取消報到" },
      ],

      intentionOptions: [
        { key: "未回覆", value: "未回覆" },
        { key: "願意報到", value: "願意報到" },
        { key: "婉拒報到", value: "婉拒報到" },
      ],

      // 分頁
      totalPerson: 0, // 共幾筆
      currentPage: 1, // 當前第幾頁

      // 檢視歷程
      Name: null,
      UserId: null,
      Email: null,
    };
  },

  methods: {
    // 取得 任用結果
    getAppointResult() {
      let candidateStatus, onBoardStatus, reportIntention;
      candidateStatus = this.getStatusString(this.searchCondition.Status);
      onBoardStatus = this.getStatusString(this.searchCondition.OnBoard);
      reportIntention = this.getStatusString(this.searchCondition.Intention);

      this.updateLoading(true);
      this.$store.commit("ScrollTop", true);

      this.$api.jobManagement
        .getAppointmentResultPaging(
          {
            Keyword: this.searchCondition.Keyword,
            interviewDateStart: this.searchCondition.InterviewDateRange
              ? this.$common.dateFormatter(
                  this.searchCondition.InterviewDateRange[0]
                )
              : null,
            interviewDateEnd: this.searchCondition.InterviewDateRange
              ? this.$common.dateFormatter(
                  this.searchCondition.InterviewDateRange[1]
                )
              : null,
            ApprovalResult: candidateStatus,
            OnBoard: onBoardStatus,
            Intention: reportIntention,
            Page: this.currentPage,
            PerPage: 9,
          },
          this.did
        )
        .then((response) => {
          if (response.status === 200) {
            if (response.data.Quantity > 0) {
              this.totalPerson = response.data.Quantity;
              this.personList = response.data.Datas;
              this.$store.commit("ScrollTop", false);
            }
          }
          this.updateLoading(false);
        });
    },

    getStatusString(obj) {
      return obj && Object.keys(obj).length > 0 ? String(obj) : null;
    },

    // 換頁
    changePage(page) {
      this.currentPage = page;
      this.getAppointResult();
    },

    // 更新卡片
    updatePerson(matchId, action) {
      switch (action) {
        case "錄取通知":
          this.personList.forEach((item, index, arr) => {
            if (item.MatchId === matchId) {
              arr[index].HireNoticeMailTime = this.$common.getTime();
            }
          });
          break;
        case "報到通知":
          this.personList.forEach((item, index, arr) => {
            if (item.MatchId === matchId) {
              arr[index].ReportNoticeMailTime = this.$common.getTime();
            }
          });
          break;
      }
    },

    // 錄取 & 報到通知
    sendMail(person, type) {
      this.personData = person;
      type === "hire"
        ? this.$store.commit("OpenHireMailModal", true)
        : this.$store.commit("OpenReportMailModal", true);
    },

    // 履歷 Note
    clickResumeNote(person) {
      this.interviewee = person;
      this.$store.dispatch("getResumeSummary", person.MatchId);
      this.$store.commit("OpenResumeNoteModal", true);
    },

    // 檢視資訊 Modal
    showDetailModal(item) {
      this.MatchId = item.MatchId;
      this.ResumeId = item.ResumeId;
      this.ResumeType = item.ResumeType;
      this.isShowDetail = true;
    },

    // 檢視歷程
    showProgressRecord(person) {
      this.MatchId = person.Id;
      this.Name = person.Name;
      this.UserId = person.UserId;
      this.Email = person.Email;
      this.$store.commit("OpenCandidateProcessModal", true);
    },

    // hcp
    clickHcpData(person) {
      this.personData = person;
      this.$store.commit("OpenHcpDataModal", true);
    },

    // 報到確認 Modal
    async openOnBoardModal(person) {
      this.updateLoading(true);
      // 取得 報到未到分類選項
      const notArrivedCategory = await this.$api.onBoard.getNotArrivedCategory(
        person.MatchId
      );
      this.notArrivedCategoryOptions = notArrivedCategory.data.map(
        (category) => {
          return {
            value: category.Guid,
            label: category.Name,
            children: category.Children.map((children) => {
              return {
                value: children.Guid,
                label: children.Name,
              };
            }),
          };
        }
      );

      // 取得 報到狀態資訊
      const status = await this.$api.onBoard.getOnBoardStatus(person.MatchId);
      this.person = {
        MatchId: person.MatchId,
        Name: person.Name,
        Position: person.Position,
        ...status.data,
        notArrivedCategory: [
          status.data.NotArrivedCategoryGuid,
          status.data.NotArrivedCategorySecondGuid,
        ],
        NewOnBoardDate: status.data.OnBoardTime
          ? status.data.OnBoardTime.split("T")[0]
          : null,
      };
      this.updateLoading(false);
      this.$refs.reported.reset();
      $("#checkOnBoardModal").modal("show");
    },

    // 報到確認
    confirmedOnBoard() {
      $("#checkOnBoardModal").modal("hide");
      this.updateLoading(true);
      this.$api.recruitment
        .onBoard({
          MatchId: this.person.MatchId,
          OnBoardStatus: this.person.OnBoardStatus,
          NewOnBoardDate: this.person.NewOnBoardDate,
          OnBoardRemark: this.person.OnBoardRemark,
          NotArrivedCategoryGuid:
            this.person.notArrivedCategory.length > 0
              ? this.person.notArrivedCategory[0]
              : null,
          NotArrivedCategorySecondGuid:
            this.person.notArrivedCategory.length > 0
              ? this.person.notArrivedCategory[1]
              : null,
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "確認成功",
              type: "success",
              duration: 2500,
            });
            this.$store.dispatch("AppointResult");
            this.currentPage = 1;
            this.getAppointmentResult();
          }
          this.updateLoading(false);
        });
    },

    // 下載 Offer (Excel)
    exportOffer() {
      this.updateLoading(true);
      this.$api.recruitment
        .downloadOffer({
          MatchIds: this.choosePersonList.map((item) => item.MatchId),
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.type === "application/json") {
              let reader = new FileReader();
              reader.readAsText(response.data, "utf-8");
              reader.onload = () => {
                const { ErrorMessage } = JSON.parse(reader.result);
                this.$notify({
                  title: "失敗",
                  message: ErrorMessage,
                  type: "error",
                  duration: 3500,
                });
              };
            } else {
              let fileName = decodeURIComponent(
                decodeURIComponent(
                  response.headers["content-disposition"].split(
                    "filename*=UTF-8''"
                  )[1]
                )
              );
              this.updateLoading(false);
              let blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              let url = window.URL.createObjectURL(blob);
              let a = document.createElement("a");
              a.href = url;
              a.download = fileName;
              a.click();
              window.URL.revokeObjectURL(url);
            }
          }
          this.updateLoading(false);
        });
    },

    // 即時更新選取人員之列表
    updatePersonList(choosePerson) {
      let repeatIndex = this.choosePersonList.findIndex(
        (element) => element.MatchId === choosePerson[0].MatchId
      );
      if (repeatIndex === -1) {
        this.choosePersonList.push(choosePerson[0]);
      } else {
        this.choosePersonList.splice(repeatIndex, 1);
      }
    },

    // 全選人員卡片
    selectAllCards() {
      this.personList.forEach((item) => {
        if (!item.isChecked) {
          item.isChecked = true;
        }
      });
      this.choosePersonList = this.personList.filter(
        (item) => item.isChecked === true
      );
    },

    // 清除全選
    clearSelectCard() {
      this.personList.forEach((item) => {
        item.isChecked = false;
      });
      this.choosePersonList = [];
    },

    // 卡片樣式
    changeStyle(style) {
      this.gridStyle = style;
    },

    async getData() {
      const backgroundUser = await this.$api.backgroundUser.getBackgroundUser();
      this.supervisorOptions = backgroundUser.data.map((user) => {
        return {
          Guid: user.UserId,
          Name: user.Name,
        };
      });
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  watch: {
    // 檢視資訊
    isShowDetail: function (e) {
      if (!e) {
        this.detailCurrentPage = 0;
      }
    },

    // 選取人員列表
    choosePersonList: function (e) {
      if (e.length > 0) {
        this.showActionBar = true;
        this.showSearchBar = false;
      } else {
        this.showActionBar = false;
      }
    },
  },

  created() {
    this.getData();
    this.getAppointResult();
    // 網站 url
    this.url = window.location.origin;
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.appoint-result-table {
  td {
    height: 45px !important;
  }
}

#checkOnBoardModal .modal-dialog {
  .modal-content {
    padding-top: 30px;
    .modal-header {
      display: block;
    }
    .modal-body {
      max-height: calc(100vh - 200px);
      .info {
        margin-bottom: 15px;
        .text-wrap {
          margin-top: 70px;
        }
      }
      .state-wrap {
        padding-bottom: 0;
      }
    }
  }
}

/deep/ .el-input {
  display: block;
}

/deep/ .el-select {
  display: block;
}
</style>
